import React from 'react'
import { Card, CardActionArea,CardMedia,CardContent,Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
function SpecialisteComponent({data,changeSpecialiste}) {
    return (
            <Card key={data.id} sx={{ margin: '10px',borderRadius:'20px',maxWidth: {md:300,sm:350,xs:350},':hover':{backgroundColor:grey[200]} }} onClick={() => {
                changeSpecialiste(data.id,data.nom_service)
            }} >
                <CardActionArea>
                    <CardMedia
                        component="img"
                        height="150"
                        image={data.image_service}
                        style={{ objectFit: 'contain', marginTop: 1,borderRadius:'20px' }}
                        alt="green iguana"
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h6" component="div" sx={{color: '#d82967',fontWeight:'bold'}}>
                            {data.nom_service.toUpperCase()}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {data.description_service}
                        </Typography>
                    </CardContent>
                </CardActionArea>
            </Card>
    )
}
export default SpecialisteComponent